module.exports = __webpack_public_path__ + "img/GaramontAmsterdamBQ-Medium.cd09bd4e.svg";